import { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Login from './pages/Login';
import Register from './pages/Register';
import Notes from './pages/Notes';
import './styles/auth.css';
import { Toaster } from 'react-hot-toast';
import { initGA, logPageView } from './utils/analytics';
import { GA_MEASUREMENT_ID } from './config';

function App() {
  useEffect(() => {
    // 初始化 Google Analytics
    if (GA_MEASUREMENT_ID) {
      initGA(GA_MEASUREMENT_ID);
      logPageView(); // 记录初始页面访问
    }
  }, []);

  return (
    <>
      <Toaster 
        position="top-right"
        toastOptions={{
          duration: 3000,
          style: {
            background: '#FDF6EC',
            color: '#5B8C7D',
            border: '1px solid #5B8C7D'
          },
        }}
      />
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/notes" element={<Notes />} />
          <Route path="/" element={<Login />} />
        </Routes>
      </Router>
    </>
  );
}

export default App;
